import type { GlobalStateMergedState } from 'components/GlobalState/GlobalStateModel';
import {
  type LicenseFeatureAvailability,
  getLicenseFeatureAvailability,
} from 'utils/license/licenseFeatures';

export const selectLicenseFeatureAvailability = (
  state: GlobalStateMergedState,
): LicenseFeatureAvailability => getLicenseFeatureAvailability(state.license);
